// Yang Orthodontics (Dr. Stephen Yang; Redwood City CA) - single office. Backend:
// bondLocations.ts YANG_REDWOOD_CITY (brandId "yang", catalog ed24230f, Edge loc 2,
// procedure 870, DB 293). Native booking via ortho2-newpatient backend (WCF intake
// disabled). English-only.
import type { BrandConfig } from "./types";

export const yang: BrandConfig = {
  slug: "yang",
  brandId: "yang",
  brandName: "Yang Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/dce81709-226f-400e-bcb8-e55f274eaf4b.png",
  phone: "(650) 366-5758",
  phoneHref: "tel:+16503665758",
  theme: { primary: "#0FA3A4", primaryDark: "#0B7071" }, // scoured 2026-07-20 orthodontistrwc.com (teal)
  locales: ["en"],
  locations: {
    YANG_REDWOOD_CITY: {
      id: "YANG_REDWOOD_CITY",
      name: "Redwood City",
      addressLines: ["52 Arch St, Suite 2", "Redwood City, CA 94062"],
      mapsUrl: "https://maps.google.com/?q=52+Arch+St+Suite+2+Redwood+City+CA+94062",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { REDWOOD_CITY: "YANG_REDWOOD_CITY", YANG: "YANG_REDWOOD_CITY" },
};
